/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { isNone } from '@ember/utils';
import { task } from 'ember-concurrency';
import ArrayProxy from '@ember/array/proxy';

import ActionModel from 'cio/models/action';
import SubjectModel from 'cio/models/subject';
import DS from 'ember-data';
import CampaignModel from 'cio/models/campaign';

interface ActionSubjectsPanelArgs {
  action: ActionModel;
  campaign?: CampaignModel;
}

export default class ActionSubjectsPanel extends Component<ActionSubjectsPanelArgs> {
  @service store!: DS.Store;

  @tracked continuation: number | null = null;
  @tracked lastError: any = null;
  @tracked subjects?: ArrayProxy<SubjectModel> = undefined;

  get icon() {
    if (this.args.campaign?.isWebhookTriggered) {
      return 'object';
    }

    return 'person';
  }

  fetchSubjects = task(async (continuation: any) => {
    try {
      let subjects = await this.store.query('subject', {
        action_id: this.args.action.id,
        continuation,
      });
      let { meta } = subjects as any;

      if (!isNone(meta)) {
        this.continuation = meta.continuation;
      }

      this.subjects = subjects;
      this.lastError = undefined;
    } catch (e) {
      this.lastError = e;
    }

    return continuation;
  });

  get isDataCampaign() {
    if (this.args.campaign == null) {
      return false;
    }

    return this.args.campaign.isDataCampaign;
  }
}
